<template>
  <div>
    <div class="skeleton van-skeleton van-skeleton--animate" v-if="loading">
      <div class="van-skeleton__content skelon_wrap">
        <!-- <h3 class="van-skeleton__title"></h3> -->
        <div class="van-skeleton__row height1"></div>
        
        <van-row class="skelon_item" type="flex" justify="space-between">
          <van-col span="4"><div class="van-skeleton__row height4"></div></van-col>
          <van-col span="4"><div class="van-skeleton__row height4"></div></van-col>
          <van-col span="4"><div class="van-skeleton__row height4"></div></van-col>
          <van-col span="4"><div class="van-skeleton__row height4"></div></van-col>
          <van-col span="4"><div class="van-skeleton__row height4"></div></van-col>
        </van-row>
        <div class="van-skeleton__row height2"></div>

        <van-row class="skelon_item" type="flex" justify="space-between" gutter="15">
          <van-col span="12"><div class="van-skeleton__row height5"></div></van-col>
          <van-col span="12"><div class="van-skeleton__row height5"></div></van-col>
        </van-row>

        <van-row class="skelon_item" type="flex" justify="space-between" gutter="15">
          <van-col span="12"><div class="van-skeleton__row height5"></div></van-col>
          <van-col span="12"><div class="van-skeleton__row height5"></div></van-col>
        </van-row>

      </div>
    </div>
    <slot v-if="!loading"/>
  </div>
</template>
<script>

export default {
  name: '',
  components:{

  },
  props:{
    loading:{
        type: Boolean,
        default: false
      }
  },
  data () {
    return {
      title: '',
    }
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>
.skelon_wrap{
  padding:10px 0 60px;
}
.height1{
  height: 3.4667rem;
  border-radius: 5px;
}
.height2{
  height: 2.4rem;
  border-radius: 5px;
}
.height3{
  height: 1.3333rem
}
.height4{
  height: 1.6rem;
  border-radius: 1.6rem;
}
.height5{
  height:200px;
  border-radius: 5px;
}
.skelon_item{
  margin-top: 0.32rem;
}
</style>